import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Faq from "~/views/faq"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [{ url: "/faq/info" }, { url: "/formwithcontacts/list", code: "faq" }],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Faq.getInitialProps = getInitialProps

export default Faq
